<template>
  <div class="container">
  <div v-if="showmeal">
      <div class="con" >
      <h1>套餐组合</h1>
      <goodsmealceil v-if="list.length" :mealsList = list></goodsmealceil>
      <div v-else class="empty">
       <div class="empty-img">
             <img :src="require('@/assets/images/all_tc.png')" alt="">
           </div>
      <div class="empty-con">
        <h5>暂无套餐活动</h5>
        <p>近期暂无优惠套餐活动，请继续关注套餐活动</p>
      </div>

    </div>
    </div>
    
  </div>
      <el-pagination
        class="pagination"
        background 
        layout="prev, pager, next"
        :page-size="pageSize"
        @current-change="changepage"
        :total="total"
        :current-page="pageNumber"
        v-if="list.length"
        >
      </el-pagination>

  </div>
</template>
<script>
import goodsmeal from "./components/goods-meal";
import goodsmealceil from "./components/goods-meal-ceil";
export default {
  components: { goodsmeal, goodsmealceil },
  data() {
    return {
      list: [],
      pageNumber:1,
      pageSize:20,
      total:'',
      showmeal:false
    };
  },
  methods: {
    getCombinationList() {
      this.$api.GET_COMBINATIONLIST({
        pageNumber:this.pageNumber,
        pageSize:this.pageSize
      }).then((res) => {
        if (res.status) {
          this.list = res.data;
          this.total = res.totals
          this.showmeal = true
        }
      });
    },
     changepage(val){
       this.pageNumber = val
    },
  },
  mounted() {},
  created() {
    this.getCombinationList();
  },
};
</script>
<style  lang="scss" scoped>
.container{
  background-color: #fafafa;
  padding-bottom: 40px;
      min-height: calc(100vh - 252px);
}
.con {
  overflow: hidden;
  h1 {
    font-size: 28px;
    color: #333333;
    margin: 38px 0 20px 0;
  }
}
.pagination{
  text-align: center;
  margin-top: 40px;
  color: #fa4b4b;
}
.empty{
    height: 260px;
    width: 1200px;
background-color: #fdfdfd;
border-radius: 10px;
margin-top: 50px;
  @include flex-c;
.empty-img{
  margin-right: 35px;
}
  .empty-con{
     @include flex-d-c;
    h5{
      font-size: 18px;
      color: #505050;
      margin-bottom: 22px;

    }
    p{
      font-size: 16px;
      color: #808080;
    }
  }
}
</style>>




// WEBPACK FOOTER //
// src/pages/main/meal/index.vue